import { render } from "./BuInsert.vue?vue&type=template&id=30df3da5&scoped=true"
import script from "./BuInsert.vue?vue&type=script&lang=js"
export * from "./BuInsert.vue?vue&type=script&lang=js"

import "./BuInsert.vue?vue&type=style&index=0&id=30df3da5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30df3da5"]])

export default __exports__